module.exports = __webpack_public_path__ + "static/img/YORK老师_Elaine.1599804.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/YORK/YORK老师_Elaine.png
// module id = iCgJ
// module chunks = 0